import React from "react";
import { Box, Typography, Container, Grid } from "@mui/material";
import { motion } from "framer-motion";
import { Clock, MessageSquare, Target, HelpCircle } from "lucide-react";

const metrics = [
  {
    icon: Clock,
    value: "40%",
    label: "Reduction in report turnaround time",
    color: "rgba(53, 103, 214, 0.1)",
    textColor: "#3567D6",
  },
  {
    icon: MessageSquare,
    value: "3X",
    label: "Increase in patient communication engagement",
    color: "rgba(60, 208, 255, 0.1)",
    textColor: "#3CD0FF",
  },
  {
    icon: Target,
    value: "25%",
    label: "Increase in diagnostic accuracy support",
    color: "rgba(198, 96, 95, 0.1)",
    textColor: "#C6605F",
  },
  {
    icon: HelpCircle,
    value: "60%",
    label: "Fewer patient support queries",
    color: "rgba(54, 152, 104, 0.1)",
    textColor: "#369868",
  },
];

const RealResultsSection = () => {
  return (
    <Box
      component="section"
      className="section-padding"
      sx={{
        backgroundColor: "#ffffff",
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2rem", md: "2.5rem" },
              fontWeight: 700,
              color: "#3567D6",
              mb: 2,
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            Real Results, Real Impact
          </Typography>
          <Typography
            sx={{
              color: "#7F7F7F",
              maxWidth: "42rem",
              mx: "auto",
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            Measured outcomes from leading diagnostic chains and hospital
            networks that implemented NirogGyan Smart Reporting.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {metrics.map((metric, index) => {
            const IconComponent = metric.icon;
            return (
              <Grid item xs={6} md={3} key={index}>
                <Box
                  component={motion.div}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  sx={{
                    textAlign: "center",
                  }}
                >
                  <Box
                    sx={{
                      width: "56px",
                      height: "56px",
                      borderRadius: "16px",
                      backgroundColor: metric.color,
                      color: metric.textColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mx: "auto",
                      mb: 2,
                    }}
                  >
                    <IconComponent size={24} />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 700,
                      color: "#1D47A4",
                      mb: 1,
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    {metric.value}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      color: "#7F7F7F",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    {metric.label}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

export default RealResultsSection;

